// extracted by mini-css-extract-plugin
export default {"pm-info-btn":"PaperMatrix_pm-info-btn__VsUyN","selected-options":"PaperMatrix_selected-options__XVc02","table":"PaperMatrix_table__GCHmc"};